import React from 'react';

import { useCurrentProjectId, useAlloyFeatureFlag } from '@adsk/alloy-provider';
import A from '@adsk/alloy-react-a';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { Package } from '../../types';
import { getDeepLink } from '../../utils/deepLink';

interface PackageCellProps {
  pkg: Package;
}

const PackageCell: React.FC<PackageCellProps> = ({ pkg }) => {
  const projectId = useCurrentProjectId() || '';
  const { value: isCustomReviewEnabled } = useAlloyFeatureFlag(
    'submittals-crw-fe',
    true,
  );
  return (
    <OverflowTooltip content={pkg.title} autoTipOnEllipsis>
      <div
        style={{
          color: `${theme.colors.adskBlue500}`,
        }}
      >
        <A
          target="__blank"
          href={getDeepLink(pkg, projectId, 'packages', isCustomReviewEnabled)}
          onClick={(e) => e?.stopPropagation()}
        >
          {pkg.title}
        </A>
      </div>
    </OverflowTooltip>
  );
};

PackageCell.displayName = 'SubmittalsPackageCell';
export default PackageCell;
